import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { Question, Survey } from '../shared/model-service';

@Component({
  selector: 'app-generic-display',
  templateUrl: './generic-display.component.html',
  styleUrls: ['./generic-display.component.css']
})
export class GenericDisplayComponent implements OnInit {

  @Input() Question: Question;
  @Input() CurrentSurvey: Survey

  @Output() sendingSurvey = new EventEmitter<any>();
  @Input() SurveyBase : Survey
 
  constructor() { }

  ngOnInit(): void {
  }

  saveCurrentSurvey(survey : any){
    this.sendingSurvey.emit(survey);
  }
}
